import * as React from 'react';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';

export default function Tags({ allData, setSelectedContas }) {
  const todosTipos = [...new Set(allData.map(item => item.Conta + " - " + item.Fornecedor))];
  todosTipos.sort();

    const handleChange = (event, value) => setSelectedContas(value);
  return (
    <Stack spacing={3} sx={{ margin: " 0 "}}>
      <Autocomplete
              multiple
              onChange={handleChange}
        id="contas"
        options={todosTipos.map((option) => option)}
        freeSolo
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip variant="outlined" label={option} {...getTagProps({ index })} />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Contas"
            fullWidth
          />
        )}
      />
    </Stack>
  );
}
